/* ==========================================================================
   Blinq · Custom Classic customizer  (assets/blinq-customizer-classic.js)
   Markup: snippets/blinq-customizer-classic.liquid · Styles: blinq-customizer-classic.css
   Used by sections/blinq-product-classic.liquid.

   This is the script from snippets/blinq-custom-classic.liquid (the live PVC
   customizer), moved into a cached asset file. The logic is the same, line for
   line, apart from the button wording ("Upload a logo"), the starting colour
   coming from the section setting, and ONE visibility change marked
   "Redesign" in refreshGates().
   Do not change the order-critical parts without testing a real order:
     - the proof gate and invalidateApproval() on every design change
     - generateFront / generateBack / the design-preview proof
     - Uploadery fields found by label, waitForFreshFront(), snapshotProps()
     - the cart/add call that only runs after the upload has finished
   Everything is found by element id (bc...), so the markup can be restyled
   freely as long as every id stays.

   After it, two small add-ons: the price on the Add to cart button follows the
   quantity ("Add to cart - $59.99"), and Enter / Space opens the logo picker.
   ========================================================================== */
(function(){
  var BLEED_W = 2114;
  var BLEED_H = 1370;
  var SAFE_OFFSET = 95;
  var RATIO = BLEED_W / BLEED_H;
  var SAFE_L = SAFE_OFFSET / BLEED_W * 100;
  var SAFE_T = SAFE_OFFSET / BLEED_H * 100;
  var SAFE_R = 100 - SAFE_L, SAFE_B = 100 - SAFE_T;
  var SAFE_MAX_W = SAFE_R - SAFE_L;
  var SNAP_PX = 6;

  var FONTS = {
    inter:   { label: 'Inter',        family: '"Inter"',          fallback: 'sans-serif' },
    poppins: { label: 'Poppins',      family: '"Poppins"',        fallback: 'sans-serif' },
    serif:   { label: 'Source Serif', family: '"Source Serif 4"', fallback: 'serif' }
  };
  function fontStack(key){ return FONTS[key].family + ', ' + FONTS[key].fallback; }
  var currentFont = 'inter';

  // Starting card colour: the section's "Default card colour" setting (data-default-color),
  // else the original coral.
  var bczRoot = document.getElementById('bc-customizer');
  var DEFAULT_COLOR = ((bczRoot && bczRoot.getAttribute('data-default-color')) || '#FF6552').toUpperCase();
  var userHasPicked = false;
  var currentColor = DEFAULT_COLOR;
  var logoDataURL = null;
  var logoFileName = '';

  // Proof gate. approveOK is the customer's signature on THIS exact design; noLogoOK is a
  // separate acknowledgement that only applies when the card carries no logo at all.
  var approveOK = false;
  var noLogoOK = false;

  function $(id){ return document.getElementById(id); }

  var card = $('bcCard');
  var cardBack = $('bcCardBack');
  var cardWrap = $('bcCardWrap');
  if (!card) return;

  var state = {
    logo:  { x: 35,  y: 12,   w: 30,  aspect: 1, visible: false },
    name:  { x: 30,  y: 60,   size: 5,   text: '', weight: 600, visible: false },
    title: { x: 32,  y: 70,   size: 3.8, text: '', weight: 400, visible: false }
  };
  var domEls = { logo: $('bcLogoWrap'), name: $('bcNameEl'), title: $('bcTitleEl') };
  var snapV = $('bcSnapV'), snapH = $('bcSnapH');
  var selected = null;
  var currentTextColor = '#FFFFFF';
  var autoLayout = true;

  // -------------------------------------------------------------------------
  // PROOF GATE
  // -------------------------------------------------------------------------
  function hasLogoArt() { return !!logoDataURL && state.logo.visible; }
  function hasArtwork() {
    return hasLogoArt() ||
           (state.name.visible  && state.name.text.trim().length  > 0) ||
           (state.title.visible && state.title.text.trim().length > 0);
  }

  /* Take the logo back off the card, so an upload can be undone without reloading.
     Mirrors clearLogo() in the engraved configurators, minus the tinted-bitmap and
     SVG-trim state that only laser engraving needs. */
  function clearLogo() {
    logoDataURL = null;
    logoFileName = '';
    state.logo.visible = false;
    var picker = $('bcHiddenFileInput');
    if (picker) picker.value = '';                 // let them re-pick the same file later
    var lbl = $('bcUploadLabel');
    if (lbl) lbl.textContent = 'Upload a logo';
    var pv = $('bcLogoPreview');
    if (pv) pv.src = '';
    if (selected === 'logo') deselect();
    autoLayout = true;
    layout('logo');                                // hides it + refreshes the placeholder
    arrangeStack();                                // re-center any remaining name/title
    updateProps();
    invalidateApproval();                          // also re-runs refreshGates()
  }

  function showErr(html) {
    var el = $('bcErr');
    if (!el) return;
    if (!html) { el.classList.remove('is-on'); el.innerHTML = ''; return; }
    el.innerHTML = html;
    el.classList.add('is-on');
    if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function flash(id) {
    var box = $(id);
    if (!box) return;
    box.classList.remove('bc-flash');
    void box.offsetWidth;
    box.classList.add('bc-flash');
    if (box.scrollIntoView) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function refreshGates() {
    var box = $('bcApproveBox');
    if (box) {
      // Nothing to approve until there is a design, so the box only appears once the
      // customer has actually put something on the card.
      box.classList.toggle('bc-visible', hasArtwork());
      box.classList.toggle('bc-done', approveOK && (hasLogoArt() || noLogoOK));
    }
    var nl = $('bcNoLogoRow');
    // Redesign (Figma "Shopify R1 / Custom / Classic"): the no-logo tick is shown whenever
    // the card has no logo, not only once there is text, so the proof card reads the same
    // as the design from the start. What it records is unchanged (see updateProps).
    if (nl) nl.classList.toggle('bc-visible', !hasLogoArt());
    // "Remove logo" is only offered once there is a logo to remove.
    var rm = $('bcRemoveBtn');
    if (rm) rm.classList.toggle('bc-visible', hasLogoArt());
    // NOTE: the theme's Add to cart button is deliberately NOT disabled. Concept reads a
    // disabled add button as "out of stock" and swaps in its back-in-stock UI, which is
    // both wrong and alarming. The purchase is blocked in the submit handler instead.
  }

  /* Any change to the design invalidates a previous approval — otherwise a customer could
     tick the box, then change the card color, the text or the layout, and buy a card they
     never actually saw. On this product the color picker counts as a design change too,
     because the color IS the card. */
  function invalidateApproval() {
    if (!approveOK) { refreshGates(); return; }
    approveOK = false;
    var cb = $('bcApprove');
    if (cb) cb.checked = false;
    refreshGates();
    updateProps();
  }

  // CMYK conversion + gamut check
  function hexToCmyk(hex) {
    var r = parseInt(hex.slice(1,3),16)/255;
    var g = parseInt(hex.slice(3,5),16)/255;
    var b = parseInt(hex.slice(5,7),16)/255;
    var k = 1 - Math.max(r,g,b);
    if (k === 1) return {c:0,m:0,y:0,k:100};
    var c = Math.round((1-r-k)/(1-k)*100);
    var m = Math.round((1-g-k)/(1-k)*100);
    var y = Math.round((1-b-k)/(1-k)*100);
    k = Math.round(k*100);
    return {c:c,m:m,y:y,k:k};
  }

  function cmykToRgb(c,m,y,k) {
    return {
      r: Math.round(255*(1-c/100)*(1-k/100)),
      g: Math.round(255*(1-m/100)*(1-k/100)),
      b: Math.round(255*(1-y/100)*(1-k/100))
    };
  }

  function rgbToHex(r,g,b) {
    return '#'+[r,g,b].map(function(v){return v.toString(16).padStart(2,'0')}).join('');
  }

  function checkGamut(hex) {
    var cmyk = hexToCmyk(hex);
    var back = cmykToRgb(cmyk.c,cmyk.m,cmyk.y,cmyk.k);
    var or = parseInt(hex.slice(1,3),16);
    var og = parseInt(hex.slice(3,5),16);
    var ob = parseInt(hex.slice(5,7),16);
    var dE = Math.sqrt(Math.pow(or-back.r,2)+Math.pow(og-back.g,2)+Math.pow(ob-back.b,2));
    return { cmyk: cmyk, outOfGamut: dE > 22, printHex: rgbToHex(back.r,back.g,back.b) };
  }

  // Native color picker
  var nativeColorInput = $('bcNativeColorInput');

  function updateUI(hex, fromUser) {
    if (fromUser) userHasPicked = true;
    currentColor = hex;
    $('bcColorBtnSwatch').style.background = hex;
    if (userHasPicked) $('bcColorLabel').textContent = 'Change color';

    var gamut = checkGamut(hex);
    var cmyk = gamut.cmyk;
    $('bcPropCmyk').value = 'cmyk('+cmyk.c+','+cmyk.m+','+cmyk.y+','+cmyk.k+')';

    var warn = $('bcGamutWarn');
    if (gamut.outOfGamut) {
      warn.style.display = 'block';
      warn.textContent = '⚠️ This color may look different when printed. Closest printable color: ' + gamut.printHex;
    } else {
      warn.style.display = 'none';
    }

    card.style.backgroundColor = hex;
    cardBack.style.backgroundColor = hex;
    applyTextColor();
    if (fromUser) invalidateApproval();   // different color -> different proof
    updateProps();
  }

  nativeColorInput.addEventListener('input', function() {
    updateUI(this.value.toUpperCase(), true);
  });
  nativeColorInput.addEventListener('change', function() {
    updateUI(this.value.toUpperCase(), true);
  });

  // Layout engine
  function cardRect(){ return card.getBoundingClientRect(); }

  function boxPct(key) {
    var st = state[key];
    if (key === 'logo') return { w: st.w, h: st.w * RATIO / st.aspect };
    var r = domEls[key].getBoundingClientRect(), c = cardRect();
    if (!c.width) return { w: 0, h: 0 };
    return { w: r.width / c.width * 100, h: r.height / c.height * 100 };
  }

  function clampPos(key) {
    var st = state[key], b = boxPct(key);
    st.x = Math.min(Math.max(st.x, SAFE_L), Math.max(SAFE_L, SAFE_R - b.w));
    st.y = Math.min(Math.max(st.y, SAFE_T), Math.max(SAFE_T, SAFE_B - b.h));
  }

  function applySnap(key) {
    var st = state[key], b = boxPct(key), c = cardRect();
    if (!c.width) return;
    var thX = SNAP_PX / c.width * 100, thY = SNAP_PX / c.height * 100;
    var xT = [SAFE_L, 50, SAFE_R], yT = [SAFE_T, 50, SAFE_B];
    Object.keys(state).forEach(function(k) {
      if (k === key || !state[k].visible) return;
      var ob = boxPct(k), o = state[k];
      xT.push(o.x, o.x + ob.w / 2, o.x + ob.w);
      yT.push(o.y, o.y + ob.h / 2, o.y + ob.h);
    });
    var xEdges = [{ v: st.x, o: 0 }, { v: st.x + b.w / 2, o: b.w / 2 }, { v: st.x + b.w, o: b.w }];
    var yEdges = [{ v: st.y, o: 0 }, { v: st.y + b.h / 2, o: b.h / 2 }, { v: st.y + b.h, o: b.h }];
    var bestX = null;
    xEdges.forEach(function(e) { xT.forEach(function(t) {
      var d = Math.abs(e.v - t);
      if (d < thX && (!bestX || d < bestX.d)) bestX = { d: d, x: t - e.o, g: t };
    }); });
    var bestY = null;
    yEdges.forEach(function(e) { yT.forEach(function(t) {
      var d = Math.abs(e.v - t);
      if (d < thY && (!bestY || d < bestY.d)) bestY = { d: d, y: t - e.o, g: t };
    }); });
    if (bestX) { st.x = bestX.x; snapV.style.left = bestX.g + '%'; snapV.style.display = 'block'; }
    else snapV.style.display = 'none';
    if (bestY) { st.y = bestY.y; snapH.style.top = bestY.g + '%'; snapH.style.display = 'block'; }
    else snapH.style.display = 'none';
  }
  function hideSnap() { snapV.style.display = 'none'; snapH.style.display = 'none'; }

  function layout(key) {
    var st = state[key], el = domEls[key];
    if (!st.visible) {
      el.style.display = 'none';
      if (selected === key) deselect();
      updatePlaceholder();
      updateProps();
      return;
    }
    el.style.display = 'block';
    if (key === 'logo') {
      el.style.width = st.w + '%';
      el.style.height = (st.w * RATIO / st.aspect) + '%';
    } else {
      el.textContent = st.text;
      el.style.fontFamily = fontStack(currentFont);
      el.style.fontSize = (st.size / 100 * cardRect().width) + 'px';
      el.style.color = currentTextColor;
      var b = boxPct(key);
      if (b.w > SAFE_MAX_W) {
        st.size = st.size * SAFE_MAX_W / b.w;
        el.style.fontSize = (st.size / 100 * cardRect().width) + 'px';
      }
    }
    clampPos(key);
    el.style.left = st.x + '%';
    el.style.top = st.y + '%';
    updatePlaceholder();
    updateProps();
    if (selected === key) updateHandles();
  }

  function layoutAll(){ Object.keys(state).forEach(layout); }

  var STACK_GAP = 4;

  function textBlockH() {
    var ks = ['name','title'].filter(function(k){ return state[k].visible; });
    if (!ks.length) return 0;
    return ks.reduce(function(s,k){ return s + boxPct(k).h; }, 0) + STACK_GAP * (ks.length - 1);
  }

  function arrangeStack() {
    if (!autoLayout) return;
    var order = ['logo','name','title'].filter(function(k){ return state[k].visible; });
    if (!order.length) return;
    var GAP = STACK_GAP;
    order.forEach(function(k){
      var el = domEls[k];
      el.style.display = 'block';
      if (k === 'logo') {
        el.style.width = state[k].w + '%';
        el.style.height = (state[k].w * RATIO / state[k].aspect) + '%';
      } else {
        el.textContent = state[k].text;
        el.style.fontFamily = fontStack(currentFont);
        el.style.fontSize = (state[k].size / 100 * cardRect().width) + 'px';
      }
    });
    var h = {}, w = {};
    order.forEach(function(k){ var b = boxPct(k); h[k] = b.h; w[k] = b.w; });
    if (state.logo.visible) {
      state.logo.x = (100 - w.logo) / 2;
      state.logo.y = (100 - h.logo) / 2;
    }
    var texts = order.filter(function(k){ return k !== 'logo'; });
    if (texts.length) {
      var total = texts.reduce(function(s,k){ return s + h[k]; }, 0) + GAP * (texts.length - 1);
      var y;
      if (state.logo.visible) {
        y = state.logo.y + h.logo + GAP;
        y = Math.min(y, SAFE_B - total);
      } else {
        y = SAFE_T + Math.max(0, (SAFE_B - SAFE_T - total) / 2);
      }
      texts.forEach(function(k){
        state[k].y = y;
        state[k].x = (100 - w[k]) / 2;
        y += h[k] + GAP;
      });
    }
    order.forEach(layout);
  }

  function updatePlaceholder() {
    var any = state.logo.visible || state.name.visible || state.title.visible;
    $('bcPlaceholder').style.display = any ? 'none' : 'flex';
    $('bcResizeHint').style.display = any ? 'block' : 'none';
    cardWrap.classList.toggle('bc-has-content', any);
  }

  var handles = {
    tl: $('bcHandleTL'), tr: $('bcHandleTR'),
    bl: $('bcHandleBL'), br: $('bcHandleBR')
  };

  function updateHandles() {
    if (!selected) return;
    var r = domEls[selected].getBoundingClientRect();
    var p = cardWrap.getBoundingClientRect();
    var top = r.top - p.top, left = r.left - p.left;
    handles.tl.style.top = top+'px';            handles.tl.style.left = left+'px';
    handles.tr.style.top = top+'px';            handles.tr.style.left = (left+r.width)+'px';
    handles.bl.style.top = (top+r.height)+'px'; handles.bl.style.left = left+'px';
    handles.br.style.top = (top+r.height)+'px'; handles.br.style.left = (left+r.width)+'px';
  }

  function select(key) {
    if (selected && selected !== key) domEls[selected].classList.remove('bc-selected');
    selected = key;
    domEls[key].classList.add('bc-selected');
    cardWrap.classList.add('bc-editing');
    Object.values(handles).forEach(function(h){ h.style.display = 'block'; });
    updateHandles();
  }

  function deselect() {
    if (selected) domEls[selected].classList.remove('bc-selected');
    selected = null;
    cardWrap.classList.remove('bc-editing');
    Object.values(handles).forEach(function(h){ h.style.display = 'none'; });
  }

  document.addEventListener('pointerdown', function(e) {
    if (!cardWrap.contains(e.target)) { deselect(); return; }
    if (e.target === card) deselect();
  });

  Object.keys(domEls).forEach(function(key) {
    domEls[key].addEventListener('pointerdown', function(e) {
      e.preventDefault(); e.stopPropagation();
      select(key);
      var st = state[key], c = cardRect();
      var sx = e.clientX, sy = e.clientY, ox = st.x, oy = st.y;
      var moved = false;
      function mv(e2) {
        autoLayout = false;
        if (!moved) { moved = true; invalidateApproval(); }   // moved artwork -> re-approve
        st.x = ox + (e2.clientX - sx) / c.width * 100;
        st.y = oy + (e2.clientY - sy) / c.height * 100;
        applySnap(key);
        layout(key);
      }
      function up() {
        hideSnap();
        document.removeEventListener('pointermove', mv);
        document.removeEventListener('pointerup', up);
      }
      document.addEventListener('pointermove', mv);
      document.addEventListener('pointerup', up);
    });
  });

  Object.keys(handles).forEach(function(corner) {
    handles[corner].addEventListener('pointerdown', function(e) {
      if (!selected) return;
      e.preventDefault(); e.stopPropagation();
      var key = selected, st = state[key];
      var startX = e.clientX, c = cardRect();
      var dir = (corner === 'tl' || corner === 'bl') ? -1 : 1;
      var startW = st.w, startSize = st.size;
      var startBox = boxPct(key);
      var cx = st.x + startBox.w / 2, cy = st.y + startBox.h / 2;
      var resized = false;
      function mv(e2) {
        if (!resized) { resized = true; invalidateApproval(); }  // resized -> re-approve
        var deltaPct = (e2.clientX - startX) * dir / c.width * 100 * 2;
        if (key === 'logo') {
          var wCap = SAFE_MAX_W;
          if (autoLayout && (state.name.visible || state.title.visible)) {
            var maxH = 2 * (SAFE_B - STACK_GAP - textBlockH() - 50);
            wCap = Math.min(wCap, Math.max(8, maxH * st.aspect / RATIO));
          }
          st.w = Math.min(wCap, Math.max(8, startW + deltaPct));
        } else {
          var factor = startBox.w > 0 ? startSize / startBox.w : 0.3;
          var sCap = 16;
          if (autoLayout) {
            var avail = SAFE_B - SAFE_T;
            if (state.logo.visible) avail = SAFE_B - (50 + boxPct('logo').h / 2) - STACK_GAP;
            var otherKey = key === 'name' ? 'title' : 'name';
            if (state[otherKey].visible) avail -= boxPct(otherKey).h + STACK_GAP;
            sCap = Math.min(sCap, Math.max(2, avail / RATIO));
          }
          st.size = Math.min(sCap, Math.max(2, startSize + deltaPct * factor));
        }
        if (autoLayout) {
          arrangeStack();
        } else {
          var nb;
          if (key === 'logo') {
            nb = { w: st.w, h: st.w * RATIO / st.aspect };
          } else {
            domEls[key].style.fontSize = (st.size / 100 * cardRect().width) + 'px';
            nb = boxPct(key);
          }
          st.x = cx - nb.w / 2;
          st.y = cy - nb.h / 2;
          layout(key);
        }
      }
      function up() {
        document.removeEventListener('pointermove', mv);
        document.removeEventListener('pointerup', up);
      }
      document.addEventListener('pointermove', mv);
      document.addEventListener('pointerup', up);
    });
  });

  window.addEventListener('resize', function() {
    layoutAll();
    if (selected) updateHandles();
  });

  // Logo upload
  var hiddenInput = $('bcHiddenFileInput');
  $('bcUploadBtn').addEventListener('click', function() {
    showErr(null);
    hiddenInput.click();
  });

  var removeBtn = $('bcRemoveBtn');
  if (removeBtn) removeBtn.addEventListener('click', function() {
    clearLogo();
    showErr(null);
  });

  hiddenInput.addEventListener('change', function() {
    var file = this.files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function(e) {
      // Hold the new data URL aside until the browser proves it can decode it. Assigning
      // logoDataURL up front meant an undecodable file (a TIFF, a corrupt PNG, a PDF picked
      // through "All files" — accept="image/*" is a filter, not enforcement) replaced a good
      // logo that had ALREADY been approved: probe.onerror only showed a message, so the
      // approval survived and the preview kept showing the old mark, while generateFront
      // rasterized the card from the broken URL and silently dropped the logo entirely.
      var pendingURL = e.target.result;
      var probe = new Image();
      probe.onload = function() {
        logoDataURL = pendingURL;
        var st = state.logo;
        st.aspect = probe.width / probe.height || 1;
        var maxByHeight = 0.5 * (SAFE_B - SAFE_T) * st.aspect / RATIO;
        st.w = Math.min(30, maxByHeight, SAFE_MAX_W);
        st.visible = true;
        logoFileName = file.name;
        $('bcLogoPreview').src = logoDataURL;
        $('bcUploadLabel').textContent = file.name.length > 20 ? file.name.substring(0,20)+'...' : file.name;
        invalidateApproval();          // new logo -> new proof
        arrangeStack();
        select('logo');
        refreshGates();
      };
      probe.onerror = function() {
        showErr('That file could not be read as an image. Please upload a PNG, JPG or SVG.');
      };
      probe.src = pendingURL;
    };
    reader.readAsDataURL(file);
  });

  // Name / job title
  function bindText(inputId, key) {
    $(inputId).addEventListener('input', function() {
      var st = state[key];
      st.text = this.value;
      var wasVisible = st.visible;
      st.visible = this.value.trim().length > 0;
      invalidateApproval();            // changed wording -> re-approve
      if (autoLayout) arrangeStack(); else layout(key);
      if (st.visible && !wasVisible) select(key);
      updateTextControls();
      refreshGates();
    });
  }
  bindText('bcNameInput', 'name');
  bindText('bcTitleInput', 'title');

  function updateTextControls() {
    var any = state.name.visible || state.title.visible;
    $('bcTextColorRow').classList.toggle('bc-visible', any);
    $('bcFontRow').classList.toggle('bc-visible', any);
  }

  Array.prototype.forEach.call(document.querySelectorAll('#bcFontRow .bc-font-btn'), function(btn) {
    btn.addEventListener('click', function() {
      currentFont = this.dataset.font;
      document.querySelectorAll('#bcFontRow .bc-font-btn').forEach(function(b){ b.classList.remove('bc-font-active'); });
      this.classList.add('bc-font-active');
      invalidateApproval();            // different typeface -> different proof
      var reflow = function(){ if (autoLayout) arrangeStack(); else { layout('name'); layout('title'); } };
      ensureFontsLoaded(reflow);
      reflow();
      updateProps();
    });
  });

  function ensureFontsLoaded(cb) {
    if (!document.fonts || !document.fonts.load) { cb(); return; }
    var fam = FONTS[currentFont].family;
    Promise.all([
      document.fonts.load('400 40px ' + fam),
      document.fonts.load('600 40px ' + fam)
    ]).then(function(){ return document.fonts.ready; }).then(function(){ cb(); }, function(){ cb(); });
  }

  var tcInput = $('bcTextColorInput');
  var tcCustom = $('bcTextColorCustom');

  function applyTextColor() {
    domEls.name.style.color = currentTextColor;
    domEls.title.style.color = currentTextColor;
  }
  function markTextColorActive() {
    var hex = currentTextColor.toUpperCase();
    document.querySelectorAll('#bcTextColorRow .bc-tc-btn, #bcTextColorRow .bc-tc-custom').forEach(function(b){ b.classList.remove('bc-tc-active'); });
    var preset = document.querySelector('#bcTextColorRow .bc-tc-btn[data-color="' + hex + '"]');
    if (preset) {
      preset.classList.add('bc-tc-active');
      tcCustom.style.background = '';
    } else {
      tcCustom.classList.add('bc-tc-active');
      tcCustom.style.background = currentTextColor;
    }
  }
  function setTextColor(hex) {
    currentTextColor = hex;
    applyTextColor();
    markTextColorActive();
    invalidateApproval();              // different text color -> different proof
    updateProps();
  }
  Array.prototype.forEach.call(document.querySelectorAll('#bcTextColorRow .bc-tc-btn'), function(btn) {
    btn.addEventListener('click', function() {
      if (tcInput) tcInput.value = this.dataset.color;
      setTextColor(this.dataset.color);
    });
  });
  if (tcInput) tcInput.addEventListener('input', function(){ setTextColor(this.value.toUpperCase()); });

  // Proof checkboxes
  var approveCb = $('bcApprove');
  if (approveCb) approveCb.addEventListener('change', function () {
    approveOK = !!this.checked;
    // The banner asked for this tick. Leaving it up once it is ticked reads as a second,
    // unrelated failure.
    if (this.checked) showErr(null);
    refreshGates(); updateProps();
  });

  var noLogoCb = $('bcNoLogo');
  if (noLogoCb) noLogoCb.addEventListener('change', function () {
    noLogoOK = !!this.checked;
    if (this.checked) showErr(null);
    refreshGates(); updateProps();
  });

  // Line-item properties
  function fmt(n){ return Math.round(n*10)/10; }
  function setProp(id, val) {
    var i = $(id);
    if (!i) return;
    i.value = val;
    i.disabled = !val;
  }
  function updateProps() {
    var gamut = checkGamut(currentColor);
    var cmyk = gamut.cmyk;
    $('bcPropColor').value = currentColor;
    $('bcPropCmyk').value = 'cmyk('+cmyk.c+','+cmyk.m+','+cmyk.y+','+cmyk.k+')';
    setProp('bcPropLogoFile', state.logo.visible ? logoFileName : '');
    setProp('bcPropLogoSize', state.logo.visible ? String(Math.round(state.logo.w)) : '');
    setProp('bcPropLogo', state.logo.visible ? 'x:'+fmt(state.logo.x)+'%, y:'+fmt(state.logo.y)+'%, w:'+fmt(state.logo.w)+'%' : '');
    setProp('bcPropName', state.name.visible ? state.name.text : '');
    setProp('bcPropNameLayout', state.name.visible ? 'x:'+fmt(state.name.x)+'%, y:'+fmt(state.name.y)+'%, size:'+fmt(state.name.size)+'%' : '');
    setProp('bcPropTitle', state.title.visible ? state.title.text : '');
    setProp('bcPropTitleLayout', state.title.visible ? 'x:'+fmt(state.title.x)+'%, y:'+fmt(state.title.y)+'%, size:'+fmt(state.title.size)+'%' : '');
    var hasText = state.name.visible || state.title.visible;
    setProp('bcPropTextColor', hasText ? currentTextColor : '');
    setProp('bcPropFont', hasText ? FONTS[currentFont].label : '');
    setProp('bcPropNoLogo', (hasArtwork() && !hasLogoArt() && noLogoOK)
      ? 'Customer acknowledged: no logo on this card' : '');
    setProp('bcPropApproved', approveOK
      ? 'Proof approved by customer. Print as shown, no changes after purchase' : '');
  }

  // Print file generation
  function generateFront(callback) {
    var pc = document.createElement('canvas');
    pc.width = BLEED_W; pc.height = BLEED_H;
    var pctx = pc.getContext('2d');

    function drawTexts() {
      ['name','title'].forEach(function(key) {
        var st = state[key];
        if (!st.visible) return;
        pctx.fillStyle = currentTextColor;
        pctx.textBaseline = 'top';
        pctx.textAlign = 'left';
        pctx.font = st.weight + ' ' + (st.size / 100 * BLEED_W) + 'px ' + fontStack(currentFont);
        pctx.fillText(st.text, st.x / 100 * BLEED_W, st.y / 100 * BLEED_H);
      });
      callback(pc);
    }

    function drawLogoThenText() {
      if (!logoDataURL || !state.logo.visible) { drawTexts(); return; }
      var img = new Image();
      img.onload = function() {
        var lw = state.logo.w / 100 * BLEED_W;
        var lh = lw / state.logo.aspect;
        pctx.drawImage(img, state.logo.x / 100 * BLEED_W, state.logo.y / 100 * BLEED_H, lw, lh);
        drawTexts();
      };
      img.onerror = function() { drawTexts(); };
      img.src = logoDataURL;
    }

    if (state.name.visible || state.title.visible) ensureFontsLoaded(drawLogoThenText);
    else drawLogoThenText();
  }

  function generateBack(callback) {
    var pc = document.createElement('canvas');
    pc.width = BLEED_W; pc.height = BLEED_H;
    callback(pc);
  }

  function canvasToFile(canvas, filename, callback) {
    canvas.toBlob(function(blob) {
      callback(new File([blob], filename, { type: 'image/png' }));
    }, 'image/png');
  }

  // -------------------------------------------------------------------------
  // UPLOAD HELPERS
  // -------------------------------------------------------------------------
  function setFileOnInput(file, input) {
    var dt = new DataTransfer();
    dt.items.add(file);
    input.files = dt.files;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* Resolve an Uploadery file input by its visible LABEL rather than by position. The old
     code took inputs[0] and inputs[1], so adding, removing or reordering a field in the
     Uploadery admin would silently swap the front and back files on every order. */
  function labelTextFor(input) {
    var t = '';
    if (input.id) {
      var l = document.querySelector('label[for="' + input.id + '"]');
      if (l) t = l.textContent || '';
    }
    if (!t) {
      var wrap = input.closest('form[data-uploadery], .uploadery-field, li, div');
      if (wrap) {
        var wl = wrap.querySelector('label');
        if (wl) t = wl.textContent || '';
      }
    }
    if (!t) {                                    // nearest preceding label sibling
      var p = input.previousElementSibling;
      while (p && !t) { if (p.tagName === 'LABEL') t = p.textContent || ''; p = p.previousElementSibling; }
    }
    return t.replace(/\s+/g, ' ').trim();
  }

  function uploaderyInput(labelRe, fallbackIndex) {
    var forms = document.querySelectorAll('#uploadery-container form[data-uploadery]');
    for (var i = 0; i < forms.length; i++) {
      var lab = forms[i].querySelector('label');
      var txt = lab ? (lab.textContent || '').replace(/\s+/g, ' ').trim() : '';
      if (txt && labelRe.test(txt)) {
        var f = forms[i].querySelector('input[type="file"]');
        if (f) return f;
      }
    }
    var all = document.querySelectorAll('#uploadery-container input[type="file"]');
    for (var j = 0; j < all.length; j++) {
      if (labelRe.test(labelTextFor(all[j]))) return all[j];
    }
    if (fallbackIndex < 0) return null;   // label-only: never guess (would hit Card Back)
    return all[fallbackIndex] || null;
  }

  /* Uploadery fails in two DIFFERENT ways that used to produce the same unhelpful "still
     loading" message:
       no-block  — the Uploadery app block is not on this product's template at all
       no-fields — the block IS there but renders empty, i.e. the Option Set is not
                   targeted at this product's URL
     Naming which one it is turns a dead end into a two-minute admin fix. */
  function uploaderyState() {
    var c = document.getElementById('uploadery-container');
    if (!c) return 'no-block';
    if (!c.querySelectorAll('input[type="file"]').length) return 'no-fields';
    return 'ok';
  }

  // Uploadery uploads each file to S3 on the file input's "change" event, then writes the
  // resulting URL into a line-item property input. The uploaded URL preserves our original
  // filename suffix, e.g. ".../<hash>-card-front.png" (confirmed against live orders), so
  // we tell the front apart from the back by that suffix — instead of counting URLs, which
  // broke when the identical blank back de-duped to one URL.
  function uploadedUrls() {
    var urls = [];
    var scopes = [];
    var uc = document.getElementById('uploadery-container');
    if (uc) scopes.push(uc);
    var f = document.querySelector('form[data-type="add-to-cart-form"]');
    if (f) scopes.push(f);
    scopes.forEach(function(scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('input'), function(inp) {
        var v = (inp.value || '').trim();
        if (/^https?:\/\/\S*(uploadery|theshoppad|amazonaws|s3)\S*/i.test(v)) urls.push(v);
      });
    });
    return urls;
  }
  function frontUrl() {
    var m = uploadedUrls().filter(function(u){ return /-card-front\.png/i.test(u); });
    return m.length ? m[m.length - 1] : null;
  }
  function backUrl() {
    var m = uploadedUrls().filter(function(u){ return /-card-back\.png/i.test(u); });
    return m.length ? m[m.length - 1] : null;
  }
  function previewUrl() {
    var m = uploadedUrls().filter(function(u){ return /-design-preview\.png/i.test(u); });
    return m.length ? m[m.length - 1] : null;
  }

  /* Everything that decides what the front PNG looks like. Two adds with the same
     signature rasterize byte-identical files, which Uploadery de-dupes to the SAME URL. */
  function designSignature() {
    return JSON.stringify([
      currentColor, currentTextColor, currentFont,
      logoFileName, logoDataURL ? logoDataURL.length : 0,
      state.logo.x, state.logo.y, state.logo.w, state.logo.aspect, state.logo.visible,
      state.name.x, state.name.y, state.name.size, state.name.text, state.name.visible,
      state.title.x, state.title.y, state.title.size, state.title.text, state.title.visible
    ]);
  }
  var lastAddedSignature = null;

  // Wait until THIS order's front has actually uploaded: the front URL must be present AND
  // different from whatever front URL was there before we dispatched (prevFront), so a
  // stale front from a previous order in the SAME browser session can never satisfy the
  // wait — that was the bug that put one person's name on every card. We also make sure a
  // back URL exists, but do NOT require it to be new: the back is an identical blank panel
  // every time, so Uploadery de-dupes it to one URL that never "changes".
  //
  // sameDesign relaxes the "must be new" rule, and is required for correctness rather than
  // convenience: a customer adding a SECOND card with an identical design produces
  // byte-identical artwork, so Uploadery hands back the SAME URL and the front can never
  // "change". Without this the wait ran the full 30 seconds and told them to try again,
  // forever. When the design really is identical, the existing URL IS this card's artwork.
  //
  // prevPreview mirrors prevFront exactly, and for the same reason. When the front is
  // fresh the proof is fresh too (its pixels are a superset of the front's), so this adds
  // no new timeout mode beyond a genuinely stuck proof upload - and previewInjected is
  // false whenever there is no field to inject into, so a store without the field behaves
  // precisely as it does today.
  function waitForFreshFront(prevFront, prevPreview, previewInjected, sameDesign, timeoutMs, onDone, onTimeout) {
    var start = Date.now();
    (function poll() {
      var fu = frontUrl(), pv = previewUrl();
      var previewReady = !previewInjected || (pv && (sameDesign || pv !== prevPreview));
      if (fu && backUrl() && previewReady && (sameDesign || fu !== prevFront)) { onDone(); return; }
      if (Date.now() - start > timeoutMs) { onTimeout(); return; }
      setTimeout(poll, 250);
    })();
  }

  var PROP_IDS = ['bcPropColor','bcPropCmyk','bcPropLogoFile','bcPropLogoSize','bcPropLogo',
                  'bcPropName','bcPropNameLayout','bcPropTitle','bcPropTitleLayout',
                  'bcPropTextColor','bcPropFont','bcPropApproved','bcPropNoLogo'];

  function ensurePropsInForm(form) {
    PROP_IDS.forEach(function(id) {
      var input = $(id);
      if (input && !form.contains(input)) form.appendChild(input);
    });
  }

  /* Uploadery's hosted-URL inputs reach the line item through the product form. On
     Concept's page its app block sat inside that form (live order #6518 carries
     logo-front / logo-back pointing at uploadery.s3.theshoppad.net/.../-card-front.png and
     -card-back.png). [Blinq] In sections/blinq-product-classic.liquid the block renders
     after the form, so copyUploaderyProps() adds them to the payload, skipping any the
     form already carries so nothing is posted twice.

     Capture the properties that describe THIS proof at the moment the artwork is
     rasterized, and post those rather than whatever the inputs hold later.

     Every design control stays live during the upload wait, which runs up to 30 seconds
     behind "Uploading your design - please keep this page open...". Re-reading the inputs
     at add time can therefore describe a design the already-uploaded PNG does not show:
     production prints what is in the file while every downstream record describes
     something else. */
  function snapshotProps() {
    var snap = [];
    PROP_IDS.forEach(function(id) {
      var i = $(id);
      if (i && i.name && !i.disabled) snap.push([i.name, i.value]);
    });
    return snap;
  }

  /* [Blinq] Copy Uploadery's line-item properties (the hosted file URLs) from its app
     block into the add-to-cart payload when the block sits outside the product form.
     Skips anything the form already carries, so a block placed inside the form is not
     posted twice. */
  function copyUploaderyProps(formData) {
    var uc = document.getElementById('uploadery-container');
    if (!uc) return;
    Array.prototype.forEach.call(
      uc.querySelectorAll('input[name], select[name], textarea[name]'), function (inp) {
        var n = inp.name || '';
        if (n.indexOf('properties[') !== 0) return;   // only line-item properties
        if (inp.type === 'file') return;              // the URL, not the raw file
        if (inp.type === 'checkbox' && !inp.checked) return;
        if (!(inp.value || '').trim()) return;
        // Skip only if the form already carries a VALUE for it. An empty field of the same
        // name in the form must not block the real link (Shopify drops empty properties,
        // so the file would silently vanish from the order).
        var cur = formData.get(n);
        if (cur && String(cur).trim()) return;
        formData.set(n, inp.value);
      });
  }


  /* Print files first: rebuild the request so the Card Front and Card Back links come
     straight after the product fields, ahead of every other property. Shopify keeps all
     properties whatever their order, but the order page lists them in this order, so the
     print files are the first thing production sees. Purely a reorder: nothing is added
     or removed, and if anything goes wrong the request is left exactly as it was. */
  function putPrintFilesFirst(formData, reFront, reBack) {
    try {
      var all = [];
      formData.forEach(function (v, k) { all.push([k, v]); });
      var isProp = function (kv) { return kv[0].indexOf('properties[') === 0; };
      var pick = function (re) {
        return all.filter(function (kv) { return isProp(kv) && typeof kv[1] === 'string' && re.test(kv[1]); });
      };
      var front = pick(reFront), back = pick(reBack);
      var rest = all.filter(function (kv) { return front.indexOf(kv) < 0 && back.indexOf(kv) < 0; });
      var ordered = rest.filter(function (kv) { return !isProp(kv); })
        .concat(front, back, rest.filter(isProp));
      if (ordered.length !== all.length) return;
      var keys = {};
      all.forEach(function (kv) { keys[kv[0]] = true; });
      Object.keys(keys).forEach(function (k) { formData.delete(k); });
      ordered.forEach(function (kv) { formData.append(kv[0], kv[1]); });
    } catch (e) {
      if (window.console) console.warn('[bc] PF-4: could not reorder the print files; sent as is.', e);
    }
  }
  /* [Blinq] Both print files must be in the add-to-cart request. Order #1001 (Oct 2026)
     reached production with only "logo-back": the front link was on the page (the upload
     wait saw it) but not in the request. Find each link in the payload by its filename
     suffix; if one is missing, add the link the page holds under a clear property name
     and note it as "_Print file check" on the line item; if the page has none either,
     report false so the add is stopped. */
  function ensurePrintFiles(formData) {
    var values = [];
    formData.forEach(function (v, k) {
      if (typeof v === 'string' && k.indexOf('properties[') === 0) values.push(v);
    });
    var has = function (re) { return values.some(function (v) { return re.test(v); }); };
    var ok = true, notes = [];
    if (!has(/-card-front\.png/i)) {
      var fu = frontUrl();
      if (fu) {
        formData.append('properties[Card Front]', fu);
        notes.push('front link recovered');
        if (window.console) console.warn('[bc] PF-1: the Card Front link was not in the request; added it from the page.');
      } else ok = false;
    }
    if (!has(/-card-back\.png/i)) {
      var bu = backUrl();
      if (bu) {
        formData.append('properties[Card Back]', bu);
        notes.push('back link recovered');
        if (window.console) console.warn('[bc] PF-2: the Card Back link was not in the request; added it from the page.');
      } else ok = false;
    }
    if (!ok) {
      if (window.console) console.error('[bc] PF-3: a print file link is missing; the card was not added.');
      return false;
    }
    // Hidden from the customer, visible on the order: lets the team see the check stepped in
    if (notes.length) formData.append('properties[_Print file check]', notes.join('; '));
    putPrintFilesFirst(formData, /-card-front\.png/i, /-card-back\.png/i);
    return true;
  }

  function applySnapshot(formData, snap) {
    PROP_IDS.forEach(function(id) {
      var i = $(id);
      if (i && i.name) formData.delete(i.name);
    });
    snap.forEach(function(kv) { formData.append(kv[0], kv[1]); });
  }

  // -------------------------------------------------------------------------
  // ADD TO CART
  // -------------------------------------------------------------------------
  /* ---------- Order proof: the approved design and the production file, side by side ---
     The print file is logo + text on a TRANSPARENT ground - the card color travels
     separately as the Card Color / Card CMYK properties - so posted raw it is white on
     white. Both panels therefore carry the same artwork, and what differs between them is
     the ground:

       LEFT   the color the customer picked, on screen, in sRGB.
       RIGHT  that color put through the same CMYK conversion the Card CMYK property
              carries and back again - i.e. roughly what comes off a UV press.

     For an engraved card the question this answers is "did the artwork survive"; for a
     printed one it is "will this color survive", which is the failure mode that actually
     bites here. A visibly different right-hand panel is a customer who is going to be
     surprised by their card, and it is worth seeing before the order ships rather than
     after.

     Every failure path degrades to "no proof image on this order": it must never block a
     purchase. */
  var PROOF_PANEL_W = 1004, PROOF_PAD = 24, PROOF_GAP = 32, PROOF_LABEL_H = 56;
  var PROOF_FONT = '-apple-system, "Segoe UI", Helvetica, Arial, sans-serif';

  function proofCardPath(ctx, w, h) {
    var r = Math.round(w * 0.0355);          // ISO card corner 3.18 mm on an 85.5 mm card
    ctx.beginPath();
    ctx.moveTo(r, 0);
    ctx.arcTo(w, 0, w, h, r);
    ctx.arcTo(w, h, 0, h, r);
    ctx.arcTo(0, h, 0, 0, r);
    ctx.arcTo(0, 0, w, 0, r);
    ctx.closePath();
  }

  function generateProofPNG(frontCanvas, callback) {
    try {
      var gamut = checkGamut(currentColor), k = gamut.cmyk;
      var cmykStr = 'CMYK(' + k.c + ',' + k.m + ',' + k.y + ',' + k.k + ')';
      var pw = PROOF_PANEL_W, ph = Math.round(pw * BLEED_H / BLEED_W);
      var W = PROOF_PAD * 2 + pw * 2 + PROOF_GAP;
      var H = PROOF_PAD * 2 + PROOF_LABEL_H + ph;
      var c = document.createElement('canvas');
      c.width = W; c.height = H;
      var x = c.getContext('2d');
      x.fillStyle = '#FFFFFF';
      x.fillRect(0, 0, W, H);

      function panel(left, ground, label, warn) {
        x.fillStyle = warn ? '#7D2418' : '#55524B';
        x.textBaseline = 'top';
        x.textAlign = 'left';
        x.font = '600 26px ' + PROOF_FONT;
        x.fillText(label, left, PROOF_PAD + 14);
        x.save();
        x.translate(left, PROOF_PAD + PROOF_LABEL_H);
        proofCardPath(x, pw, ph);
        x.clip();
        x.fillStyle = ground;
        x.fillRect(0, 0, pw, ph);
        x.drawImage(frontCanvas, 0, 0, pw, ph);   // the exact pixels the print file carries
        x.restore();
      }
      panel(PROOF_PAD, currentColor,
            'Customer preview - approved  ' + String(currentColor).toUpperCase(), false);
      panel(PROOF_PAD + pw + PROOF_GAP, gamut.printHex,
            'Production file on ' + cmykStr + (gamut.outOfGamut ? '  - OUT OF GAMUT' : ''),
            gamut.outOfGamut);
      callback(c);
    } catch (e) { callback(null); }
  }

  /* Label-only lookup: with no design-preview field we skip the proof rather than guess,
     because a positional guess would collide with the front or back field and put the
     wrong image where production expects artwork. */
  function injectProof(frontCanvas, cb) {
    var input = uploaderyInput(/design[\s_-]*preview/i, -1);
    if (!input) {
      if (window.console) console.warn('[bc] PRV-1: no "design-preview" field in the ' +
        'Uploadery Option Set, so this order carries no proof image and the Slack feed ' +
        'shows no card. Add a file field labeled exactly "design-preview" to the Option ' +
        'Set for this product.');
      cb(false);
      return;
    }
    // Uploadery throws a BLOCKING alert on a file its accept list refuses, which would
    // strand the customer mid-checkout. Check first: a misconfigured field costs us the
    // proof, never the order.
    var acc = (input.getAttribute('accept') || '').trim();
    if (acc && acc.toLowerCase().indexOf('png') === -1) {
      if (window.console) console.error('[bc] PRV-3: the design-preview field has ' +
        'accept="' + acc + '", which excludes PNG. Allow PNG on that field, or clear the ' +
        'restriction. Skipping the proof.');
      cb(false);
      return;
    }
    generateProofPNG(frontCanvas, function (canvas) {
      if (!canvas) {
        if (window.console) console.warn('[bc] PRV-2: proof render failed; the order ' +
          'proceeds without a proof image.');
        cb(false);
        return;
      }
      canvas.toBlob(function (blob) {
        if (!blob) { cb(false); return; }
        setFileOnInput(new File([blob], 'design-preview.png', { type: 'image/png' }), input);
        cb(true);
      }, 'image/png');
    });
  }

  function interceptAddToCart() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) { setTimeout(interceptAddToCart, 500); return; }

    var isProcessing = false;

    // Released once the AJAX add resolves. Without this the guard stays latched and the
    // NEXT "Add to cart" falls through to the theme's native submit before this handler
    // can regenerate anything, so a second card would be posted carrying the previous
    // card's name, job title and print file.
    function resetForNextCard() {
      isProcessing = false;
      // Each line item must be approved on its own, so the customer cannot add a second
      // card on the strength of the first card's proof tick.
      invalidateApproval();
      refreshGates();
    }

    form.addEventListener('submit', function(e) {
      // Take over this submit FIRST, before any early-out. With the guard first, a click
      // while a card is still generating would fall through to the theme's NATIVE submit
      // and post the card with whatever is in the form at that instant.
      e.preventDefault();
      e.stopImmediatePropagation();
      if (isProcessing) return;

      showErr(null);

      // Require at least ONE of: logo, name, or job title.
      var hasLogo  = state.logo.visible  && !!logoDataURL;
      var hasName  = state.name.visible  && state.name.text.trim().length  > 0;
      var hasTitle = state.title.visible && state.title.text.trim().length > 0;
      if (!hasLogo && !hasName && !hasTitle) {
        showErr('Please add <b>a logo, a name, or a job title</b> before adding to cart.');
        return;
      }

      // THE PROOF GATE. Nothing reaches the cart, and therefore nothing reaches checkout,
      // until the customer has signed off the design they can see.
      if (!approveOK) {
        flash('bcApproveBox');
        showErr('Please review the preview and tick <b>“I approve this proof”</b> before adding to cart.');
        return;
      }
      if (!hasLogo && !noLogoOK) {
        flash('bcApproveBox');
        showErr('Your card has no logo. Please tick <b>“I acknowledge my card does not have a logo”</b> to continue, or upload one.');
        return;
      }

      // Uploadery must be present and rendering its fields, or the order reaches
      // production with no print files at all.
      var us = uploaderyState();
      if (us === 'no-block') {
        showErr('Card personalization is not available on this page right now. Please refresh, ' +
                'and contact us if it keeps happening.');
        return;
      }
      if (us === 'no-fields') {
        showErr('Upload fields are still loading. Please try again in a moment.');
        return;
      }

      var frontInput = uploaderyInput(/card\s*front|front/i, 0);
      var backInput  = uploaderyInput(/card\s*back|back/i, -1);

      // Front and back MUST be two DIFFERENT fields, and the back must resolve at all. If
      // Uploadery wraps both inputs in one container, closest() finds the same first
      // <label> for both, so the back either matches nothing (null) or collides with the
      // front. Either way the order reaches production with one file instead of two.
      if (!backInput || backInput === frontInput) {
        var allFiles = document.querySelectorAll('#uploadery-container input[type="file"]');
        var recovered = null;
        for (var bi = 0; bi < allFiles.length; bi++) {
          if (allFiles[bi] !== frontInput) { recovered = allFiles[bi]; break; }
        }
        if (recovered) {
          backInput = recovered;
          if (window.console) console.warn('[bc] "Card Back" did not resolve by label, so ' +
            'field order was used instead. Check the two Uploadery labels are distinct and ' +
            'each field sits in its own wrapper.');
        }
      }

      if (!frontInput || !backInput || frontInput === backInput) {
        showErr('Upload fields are still loading. Please try again in a moment.');
        return;
      }

      updateProps();
      ensurePropsInForm(form);
      // Taken here, alongside the artwork this add will upload, so the two always agree.
      var propSnapshot = snapshotProps();
      var thisSignature = designSignature();

      var generating = $('bcGenerating');
      generating.style.display = 'block';
      generating.textContent = '⏳ Preparing print files...';

      isProcessing = true;

      function doAddToCart() {
        generating.style.display = 'none';

        // Re-assert the gate. It was checked before the artwork was generated, and every
        // design control has stayed live through the upload since. Because every design
        // change clears the approval, approveOK being false here means the customer edited
        // the card after approving it — so the uploaded PNG is already stale and this add
        // must not proceed.
        if (!approveOK) {
          isProcessing = false;
          flash('bcApproveBox');
          showErr('Your design changed while it was uploading, so the approval was cleared. ' +
                  'Please review the preview, tick <b>\u201CI approve this proof\u201D</b> ' +
                  'and add to cart again.');
          return;
        }

        var formData = new FormData(form);
        applySnapshot(formData, propSnapshot);
        // [Blinq] Uploadery's hosted-URL inputs (the print-file links) live in its own app
        // block. On Concept's product page that block sat INSIDE the product form, so
        // new FormData(form) picked them up; in sections/blinq-product-classic.liquid it
        // renders after the form, so they have to be copied in, exactly as the Eco and
        // Metal customizers do. Without this the order has no Card Front / Card Back links.
        copyUploaderyProps(formData);
        // Last check before anything reaches the cart: the payload must carry BOTH print
        // files. If a link was found on the page but did not make it into the request
        // (e.g. Uploadery kept it somewhere copyUploaderyProps does not look), it is added
        // under "Card Front" / "Card Back". If one is genuinely missing, nothing is added.
        if (!ensurePrintFiles(formData)) {
          isProcessing = false;
          showErr('Your card is still uploading. Please wait a few seconds, then press <b>Add to cart</b> again.');
          return;
        }
        var added = false;
        fetch('/cart/add', { method: 'POST', body: formData })
          .then(function(res) {
            // The old code assumed this worked and opened the drawer regardless, so a
            // rejected add looked identical to a successful one.
            if (!res || !res.ok) throw new Error('cart/add failed');
            added = true;
            return fetch('/cart.js');
          })
          .then(function(r){ return r.json(); })
          .then(function() {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var drawerBtn = document.querySelector('[aria-controls="CartDrawer"]');
            if (drawerBtn) drawerBtn.click();
          })
          .catch(function(){ /* presentation only; the add already landed or failed */ })
          .then(function(){
            if (added) { lastAddedSignature = thisSignature; resetForNextCard(); return; }
            // Deliberately NOT form.submit(). Uploadery's artwork URLs live outside the
            // product form, so a native submit posts the card with its color and text but
            // no print files, and that line item looks complete to everyone downstream.
            if (window.console) console.error('[bc] cart/add failed; not falling back to a native submit');
            isProcessing = false;
            showErr('We could not add your card to the cart. Please check your connection and try again.');
          });
      }

      // Snapshot the front URL present BEFORE this order's front uploads, so we can detect
      // the exact moment THIS order's front replaces it. This is what stops a stale front
      // (e.g. a previous order's, in the same session) reaching production.
      var prevFront = frontUrl(), prevPreview = previewUrl(), previewInjected = false;

      generateFront(function(frontCanvas) {
        injectProof(frontCanvas, function (ok) {
          previewInjected = ok;
          continueWithFront(frontCanvas);
        });
      });

      function continueWithFront(frontCanvas) {
        canvasToFile(frontCanvas, 'card-front.png', function(frontFile) {
          setFileOnInput(frontFile, frontInput);
          generateBack(function(backCanvas) {
            canvasToFile(backCanvas, 'card-back.png', function(backFile) {
              setFileOnInput(backFile, backInput);
              generating.textContent = '⏳ Uploading your design — please keep this page open...';

              waitForFreshFront(prevFront, prevPreview, previewInjected,
                                thisSignature === lastAddedSignature, 30000, function() {
                generating.textContent = '✓ Files ready — adding to cart...';
                setTimeout(doAddToCart, 300);
              }, function() {
                generating.style.display = 'none';
                isProcessing = false;
                showErr('Your card is still uploading. Please wait a few seconds, then press <b>Add to cart</b> again.');
              });
            });
          });
        });
      }
    }, true);
  }

  // Init
  updateUI(DEFAULT_COLOR);
  markTextColorActive();
  refreshGates();
  interceptAddToCart();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function(){ if (autoLayout) arrangeStack(); else { layout('name'); layout('title'); } });
  }

})();

/* ---- Add to cart label: "Add to cart - [price x quantity]" ---------------- */
(function () {
  function formatMoney(cents, format) {
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(placeholder);
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function init() {
    var total = document.querySelector('[data-bcz-total]');
    if (!total) return;
    var form = total.closest('form');
    var qty = form && form.querySelector('[name="quantity"]');
    if (!qty) return;
    var unit = parseInt(total.dataset.unitPrice, 10) || 0;
    var fmt = total.dataset.moneyFormat;
    var update = function () {
      var n = Math.max(1, parseInt(qty.value, 10) || 1);
      total.textContent = formatMoney(unit * n, fmt);
    };
    qty.addEventListener('input', update);
    qty.addEventListener('change', update);
    // The - / + buttons (assets/blinq-product.js) set the value without an event
    form.addEventListener('click', function (e) {
      if (e.target.closest('[data-bprod-qty]')) setTimeout(update, 0);
    });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---- Keyboard: Enter / Space on "Upload a logo" opens the file picker ------ */
(function () {
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest && e.target.closest('#bcUploadBtn');
    if (!btn) return;
    e.preventDefault();
    btn.click();
  });
})();